import { useAppDispatch } from "@/store";
import BaseModal from "../common/HPBaseModal";
import { modalDispatcher } from "@/store/slices/modal-slice";
import React from "react";

interface DuplicatedDashboardNameModalProps {
  action: () => void;
}

const DuplicatedDashboardNameModal: React.FC<
  DuplicatedDashboardNameModalProps
> = ({ action }) => {
  const dispatch = useAppDispatch();
  const { closeTopModal } = modalDispatcher(dispatch);

  return (
    <BaseModal
      title="Dashboard name already used"
      message="Name already used for this client. Consider adding timeframe for clarity?"
      onConfirm={action}
      onCancel={closeTopModal}
      confirmButtonText="Create Anyway"
      cancelButtonText="Rename"
    />
  );
};

export default DuplicatedDashboardNameModal;
